import { computed, nextTick, onMounted, watch } from 'vue';
import { AppMode } from '/@/api/sys/model/userModel';
import { addScript, addScriptTextContent } from '/@/utils/domUtils';

export function useAppScripts(globalConfig, user) {
  const runningMode = computed(() => {
    return globalConfig.value?.runningMode;
  });

  watch(runningMode, () => {
    if (runningMode.value === AppMode.Global) {
      handleAddBeamer();
    }
  });

  const handleAddBeamer = () => {
    // 海外线上环境
    if (['app.basic.ai'].includes(location.host)) {
      window.beamer_config = {
        product_id: 'FxAxZSas64842', //DO NOT CHANGE: This is your product code on Beamer
        //user_created_at : '2010-01-00T00:00:00Z' /*Optional: Date in which this user was created. Accepts a string in ISO-8601 format or a numeric UNIX timestamp (in milliseconds).*/
      };
      addScript({ src: 'https://app.getbeamer.com/js/beamer-embed.js' });
    }
  };

  const handleAddEmbed = () => {
    // dev环境
    if (['app.alidev.beisai.com'].includes(location.host)) {
      addScript({ src: 'https://basicai1.statuspage.io/embed/script.js' });
    }
  };

  const handleAddIntercom = () => {
    const content1 = `
        window.intercomSettings = {
          api_base: 'https://api-iam.intercom.io',
          app_id: 'dtdk88bb',
          name: '${user.value?.username}', // Full name
          user_id: '${user.value?.id}', // a UUID for your user
          email: '${user.value?.email}', // the email for your user
          created_at: '${user.value?.createdAt}', // Signup date as a Unix timestamp
        };`;
    const content2 = `// We pre-filled your app ID in the widget URL: 'https://widget.intercom.io/widget/dtdk88bb'
  (function(){var w=window;var ic=w.Intercom;if(typeof ic==="function"){ic('reattach_activator');ic('update',w.intercomSettings);}else{var d=document;var i=function(){i.c(arguments);};i.q=[];i.c=function(args){i.q.push(args);};w.Intercom=i;var l=function(){var s=d.createElement('script');s.type='text/javascript';s.async=true;s.src='https://widget.intercom.io/widget/dtdk88bb';var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s,x);};if(document.readyState==='complete'){l();}else if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})();`;

    if (['app.alidev.beisai.com'].includes(location.host)) {
      nextTick(() => {
        addScriptTextContent({ textContent: content1 });
        addScriptTextContent({ textContent: content2 });
      });
    }
  };

  onMounted(() => {
    handleAddEmbed();
    handleAddIntercom();
  });
}
